import { actionCreatorFactory } from 'typescript-fsa';
import { ApiFieldError } from 'src/types';
import {AdditionalLoan} from "src/types/AdditionalLoan";

type APIError = ApiFieldError;
type additionalLoan = AdditionalLoan;

export type createAdditionalPayload = Partial<additionalLoan>;

export type createAdditionalParams = createAdditionalPayload;
export type deleteAdditionalParams = any;
/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@manager/additionalLoans`);

export const additionalLoanRequest = actionCreator('request');

export const additionalLoanRequestSuccess = actionCreator<additionalLoan>('success');

export const additionalLoanRequestFail = actionCreator<APIError[]>('fail');

export const additionalLoanActions = actionCreator.async<
  createAdditionalParams,
  additionalLoan,
  APIError[]
  >(`create`);

export const deleteAdditionalLoanAction = actionCreator.async<
  deleteAdditionalParams,
  any,
  APIError[]
  >(`delete`);
